"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LinkedSalesObjectTitleComponent = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LinkedSalesObjectStore = _interopRequireDefault(require("crm_ui/flux/integrations/LinkedSalesObjectStore"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _generalStore = require("general-store");

var _immutable = require("immutable");

var LinkedSalesObjectTitleComponent =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LinkedSalesObjectTitleComponent, _React$Component);

  function LinkedSalesObjectTitleComponent() {
    (0, _classCallCheck2.default)(this, LinkedSalesObjectTitleComponent);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkedSalesObjectTitleComponent).apply(this, arguments));
  }

  (0, _createClass2.default)(LinkedSalesObjectTitleComponent, [{
    key: "render",
    value: function render() {
      var results = this.props.linkedSalesObjectContent.getIn(['content', 'results']);
      var resultsSize = results ? results.size : 0;
      var title = this.props.linkedSalesObject.get('title');
      return _react.default.createElement(_FormattedMessage.default, {
        message: "sidebarTitles.title",
        options: {
          title: title,
          numResults: resultsSize
        }
      });
    }
  }]);
  return LinkedSalesObjectTitleComponent;
}(_react.default.Component);

exports.LinkedSalesObjectTitleComponent = LinkedSalesObjectTitleComponent;
LinkedSalesObjectTitleComponent.propTypes = {
  linkedSalesObject: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  linkedSalesObjectContent: _propTypes.default.instanceOf(_immutable.Map)
};
LinkedSalesObjectTitleComponent.displayName = 'LinkedSalesObjectTitleComponent';

var _default = (0, _generalStore.connect)({
  linkedSalesObjectContent: {
    stores: [_LinkedSalesObjectStore.default],
    deref: function deref(props) {
      var associatedObjectId = props.associatedObjectId,
          associatedObjectType = props.associatedObjectType,
          linkedSalesObject = props.linkedSalesObject;

      var salesObject = _LinkedSalesObjectStore.default.get({
        objectTypeId: linkedSalesObject.get('objectTypeId'),
        associatedObjectId: associatedObjectId,
        associatedObjectType: associatedObjectType
      });

      return salesObject.getIn([associatedObjectType, associatedObjectId, linkedSalesObject.get('objectTypeId')]);
    }
  }
})(LinkedSalesObjectTitleComponent);

exports.default = _default;